


// Hide option to verify account with social login
$('.dokan-verify-links').closest('.dokan-panel').hide()